var text_field_default = {
  "root": "PqO3f",
  "text": "HBtv6",
  "input": "_8TjOh",
  "small": "P8MgO",
  "medium": "_8a0Na",
  "large": "oZfCN",
  "webview": "_0Mx6g",
  "endAdornment": "YXSW-",
  "shown": "TcPQ8",
  "value": "XI-qy",
  "spinner": "cUMjv",
  "spin": "DsuLe"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
